import { render, staticRenderFns } from "./GardenOrientation.vue?vue&type=template&id=3c5092e5&"
import script from "./GardenOrientation.vue?vue&type=script&lang=ts&"
export * from "./GardenOrientation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports